import { bool, node, object, oneOfType, string } from "prop-types"
import { Link } from "react-router"
import dayjs from "dayjs"

import { css } from "@emotion/react"
import { colors } from "source/shared/colors"
import { LegacyHeading, Icon } from "source/shared/components"
import { useEmbedded } from "source/calendar/hooks/useEmbedded"

EventListing.propTypes = {
  eventId: string,
  eventDate: object,
  eventTitle: string,
  campusName: string,
  locationName: string,
  eventRecurrence: string,
  eventTime: oneOfType([string, node]),
  showPagePath: string,
  signupsAvailable: bool,
}

export default function EventListing({
  eventId,
  eventDate,
  eventTitle,
  campusName,
  locationName,
  eventRecurrence,
  eventTime,
  showPagePath,
  signupsAvailable,
}) {
  const eventLocation = campusName || locationName
  const locationIconSymbol = campusName
    ? "accounts#campus"
    : "general#location-pin"
  const eventDay = dayjs(eventDate).format("YYYY-MM-DD")
  const recurs = eventRecurrence && eventRecurrence != "Does not repeat"

  return (
    <li
      css={css`
        display: flex;
        flex-direction: column;
        font-size: 14px;
        gap: 4px;
        width: 100%;
      `}
      data-eventid={eventId}
      data-date={eventDay}
    >
      <EventLink eventDay={eventDay} showPagePath={showPagePath}>
        <LegacyHeading color="brand" level={1} size={3} text={eventTitle} />
      </EventLink>

      <div>
        {eventTime}
        {recurs && (
          <span
            css={css`
              color: ${colors.tint2};
            `}
          >
            {" "}
            | {eventRecurrence}
          </span>
        )}
      </div>

      {eventLocation && (
        <div
          css={css`
            align-items: center;
            display: flex;
            gap: 4px;
          `}
        >
          <Icon
            symbol={locationIconSymbol}
            css={css`
              color: ${colors.tint2};
              font-size: 10px;
            `}
          />
          <LegacyHeading
            color="tint2"
            isUppercase
            level={2}
            size={6}
            text={eventLocation}
            weight={600}
          />
        </div>
      )}

      {signupsAvailable && (
        <div
          css={css`
            display: flex;
            flex-direction: row;
          `}
        >
          <div className="badge">Signups available</div>
        </div>
      )}
    </li>
  )
}

EventLink.propTypes = {
  eventDay: string,
  children: node,
  showPagePath: string,
}
export function EventLink({ eventDay, children, showPagePath, ...rest }) {
  const { embedded } = useEmbedded()
  return embedded ? (
    <a href={showPagePath} {...(embedded && { target: "_blank" })} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={showPagePath} state={{ eventDate: eventDay }} {...rest}>
      {children}
    </Link>
  )
}
